import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { dailyForecast, forecastForStation, hourlyForecastFor, weatherStations } from './weather-data';

@Component({
  selector: 'app-hourly-forecast',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './hourly-forecast.component.html',
  styleUrl: './hourly-forecast.component.scss',
})
export class HourlyForecastComponent {
  private readonly route = inject(ActivatedRoute);
  readonly stationId = this.route.snapshot.paramMap.get('id') || 'satara-pss';
  readonly station = weatherStations[this.stationId] || weatherStations['satara-pss'];
  readonly days = forecastForStation(this.stationId);
  readonly selectedDate = signal(this.route.snapshot.paramMap.get('date') || dailyForecast[0].key);
  readonly rows = computed(() => hourlyForecastFor(this.stationId, this.selectedDate()));
  readonly summary = computed(() => {
    const day = this.selectedDay();
    const rows = this.rows();
    return {
      peakIrradiance: Math.max(...rows.map((row) => row.irradiance)),
      peakWind: Math.max(...rows.map((row) => row.wind)),
      totalRain: Number(rows.reduce((total, row) => total + row.rain, 0).toFixed(1)),
      averageConfidence: Math.round(rows.reduce((total, row) => total + row.confidence, 0) / rows.length),
      day,
    };
  });
  readonly irradianceScale = computed(() => Math.max(...this.rows().map((row) => row.irradiance), 1));
  irradianceWidth(value: number): number { return Math.round(value / this.irradianceScale() * 100); }
  selectedDay() { return this.days.find((day) => day.key === this.selectedDate()) || this.days[0]; }
}
